// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IConsent {
    'consentEndDate'?: string;
    'consentParty': IConsent.ConsentPartyEnum;
    'consentStartDate': string;
    'consentType': IConsent.ConsentTypeEnum;
    'responseType': IConsent.ResponseTypeEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IConsent>> = [
        {
            "name":     "consentEndDate",
            "baseName": "consentEndDate",
            "type":     "string"
        },
        {
            "name":     "consentParty",
            "baseName": "consentParty",
            "type":     "string"
        },
        {
            "name":     "consentStartDate",
            "baseName": "consentStartDate",
            "type":     "string"
        },
        {
            "name":     "consentType",
            "baseName": "consentType",
            "type":     "string"
        },
        {
            "name":     "responseType",
            "baseName": "responseType",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return IConsent.attributeTypeMap;
    }
}
export namespace IConsent {
    export enum ConsentPartyEnum {
        Hcp = 'HCP',
        Patient = 'Patient',
        LegalGuardian = 'Legal Guardian',
        PatientRepresentative = 'Patient Representative'
    }
}
export namespace IConsent {
    export enum ConsentTypeEnum {
        HipaaConsent = 'HIPAA Consent',
        CopayEnrollment = 'Copay Enrollment',
        FasFcraFreeProductConsent = 'FAS/FCRA/Free Product Consent',
        NursingServicesConsent = 'Nursing Services Consent',
        TextingTcpaConsent = 'Texting/TCPA Consent',
        MarkingInfoConsent = 'Marking Info Consent',
        BroadConsent = 'Broad Consent',
        NarrowConsent = 'Narrow Consent'
    }
}
export namespace IConsent {
    export enum ResponseTypeEnum {
        Granted = 'Granted',
        Declined = 'Declined',
        Revoked = 'Revoked'
    }
}
